<template>
   <div class="employee-tab-inner">

      <b-overlay  rounded="sm" :show="showoverlay" class="trz_overlay_custom">

         <!-- <div v-if="show_loader" class="list-no-data">

          <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
        -->


         <b-form @submit.stop.prevent="onSubmit" >
            <input type="hidden" v-model="fdata.id" name="id">

            <!-- alpha fix- added class="required-field"  -->
            <b-form-group id="name-group" label="Name" class="required-field" label-for="name" v-if="((request_document_type != 'personal-tax-return-filing-ack') && (request_document_type != 'tax-documents'))">
               <b-form-input id="name" name="name" :disabled="disable_me" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
               <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="type-group" class="" label="Type" label-for="type" v-if="types_options.length > 0">
               <b-form-select id="type" name="type" v-model="fdata.type" :options="types_options" @change="checkType()"></b-form-select>
            </b-form-group>


            <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year" v-if="((request_document_type == 'personal-tax-return-filing-ack') )">
               <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" v-validate="{ required: true }" :options="this.$fiscal_year_options" :state="validateState('fiscal_year')"  aria-describedby="fiscal_year-feedback" data-vv-as="Fiscal Year"></b-form-select>
               <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year') }}</b-form-invalid-feedback>
            </b-form-group>


            <b-form-group id="submit_with_in-group" label="Deadline [YYYY-MM-DD] - Optional" label-for="submit_with_in" class="mt-4">
                  <b-input-group class="mb-3">
                     <b-form-input id="submit_with_in" name="submit_with_in" v-model="fdata.submit_with_in" type="text" placeholder="YYYY-MM-DD" autocomplete="off" ></b-form-input>
                     <b-input-group-append>
                        <b-form-datepicker id="submit_with_in" button-only right locale="en-US" :min="date_min" v-model="fdata.submit_with_in" ></b-form-datepicker>
                     </b-input-group-append>
                  </b-input-group>
            </b-form-group>


            <!-- alpha fix- added class here both btns and b-form-grop  -->
            <b-form-group label=" " class="full-width text-center mt-3" >
               <b-button type="submit" variant="primary">Submit</b-button>
               <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
            </b-form-group>
         </b-form>
      </b-overlay>

   </div>
</template>
<script>


   export default{

      mounted() {

      },
      props: [ 'employee_ids' , 'request_document_type'],
      components: {

      },
      data(){

         const now = new Date()
         const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
         const minDate = new Date(today);

         return {

            date_min:minDate,
            fdata: { id:null, name:null , type:null ,submit_with_in:'', flg:0},
            types_options: [
                  { value: null, text: "Select..." },
                  { value: "1", text: "NID" },
                  { value: "2", text: "Passport" },
                  { value: "3", text: "Educational Certificates" },
                  { value: "4", text: "Previous Employment Documents" },
               ],

            showoverlay : false,
            disable_me : false,

         }
      },
      methods:{

         checkType : function()
         {
               if((this.fdata.type < 3) && (this.fdata.id == null))
               {
                  this.fdata.name = this.types_options[this.fdata.type].text;
                  this.disable_me = true;
               }
               else
               {
                  if(this.fdata.id == null)
                  {
                     this.disable_me = false;
                     this.fdata.name = '';
                  }
               }
         },
         onSubmit(e) {

            if(!this.checkNet()) return false;

            this.$validator.validateAll().then(result => {
                  if (!result) {
                     return;
                  }

                  this.showoverlay = true;
                  e.preventDefault();
                  let currentObj = this;
                  let submit_with_in = '';
                  if(this.fdata.submit_with_in!='')
                  {
                     submit_with_in = this.fdata.submit_with_in.split('-');
                     const submit_with_in_date = new Date(submit_with_in[0],submit_with_in[1]-1, submit_with_in[2]);
                     const submit_with_in_date_final = new Date(submit_with_in_date);



                     const now2 = new Date()
                     const today2 = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate())
                     const currentDate = new Date(today2);

                     if(currentDate.getTime() > submit_with_in_date_final.getTime())
                     {
                        this.showoverlay = false;
                        this.$bvToast.toast('Deadline cannot be an older date !', {
                              title: `Error`,
                              variant: 'danger',
                              solid: true
                           });

                        return;

                     }

                  }

                  let formData = new FormData();

                  for (let [key, value] of Object.entries(this.fdata))
                  {
                     var nm = `${key}`;
                     var fval = `${value}`;
                     formData.append(nm, fval);
                     //console.log(`${key}: ${value}`);
                  }

                  formData.append('request_document_type', this.request_document_type);
                  formData.append('employee_ids', this.employee_ids);


                  axios.post(this.$api_url + '/request-documents', formData)
                     .then(function (response)
                     {
                        // this.$bvToast.toast('Saved!', {
                        //       title: `Success`,
                        //       variant: 'success',
                        //       solid: true
                        //    });

                        //this.resetForm();
                        this.showoverlay = false;

                        this.$bvModal.hide('bv-modal-request_docement');

                     }.bind(this))
                     .catch(function (error)
                     {

                           currentObj.serverError(error);
                           currentObj.errormsg = error.response.data.errors;
                     });

                     this.$bvModal.hide('bv-modal-request_docement');

                     this.$emit('childToParent');
               });

         },


      },
      created: function(){
         if(!this.checkNet()) return false;

         if(this.request_document_type == 'personal-documents')
         {
            this.types_options =  [
                  { value: null, text: "Select..." },
                  { value: "1", text: "NID" },
                  { value: "2", text: "Passport" },
                  { value: "3", text: "Educational Certificates" },
                  { value: "4", text: "Previous Employment Documents" },
               ];

         }
         else if(this.request_document_type == 'tax-documents')
         {
            this.types_options =  [
                  { value: null, text: "Select..." },
                  { value: "1", text: "eTIN" },
                  { value: "2", text: "AIT Challan" },
                  { value: "3", text: "Investment Declaration Letter" },
               ];
         }
         else
         {
            this.types_options = [];
         }


      }
   }
</script>
